<template>
  <div>
    <Navbar />
    <b-overlay :show="Loading" style="min-height:calc(100vh - 335px)">
      <div class="container" style="margin-top:100px">
        <b-row>
          <b-col sm="12" lg="12">
            <h4 @click="$router.push({ name: 'Cabinet' })"
                style="cursor:pointer">
              <!-- @click="$router.go(-1)" -->
              <b-icon-chevron-left
              ></b-icon-chevron-left>
              {{ $t("Report") }}
            </h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="12">
            <div class="pricing-box1 rounded px-4 pb-2 pt-2 mb-2 ">
              <b-row>
                <!-- <b-col sm="12" md="4" class="text-center">
                  <custom-input
                    uppertext
                    v-model="filterList.Search"
                    :placeholder="$t('search')"
                    :label="$t('search')"
                  ></custom-input>
                </b-col>
                <b-col sm="12" md="2" class="text-center">
                  <custom-select
                    :label="$t('gender')"
                    v-model="filterList.genderid"
                    :options="GenderList"
                  ></custom-select>
                </b-col>
                <b-col sm="12" md="4" class="text-center">
                  <custom-select
                    :label="$t('sporttype')"
                    v-model="filterList.sporttypeid"
                    :options="SportTypeList"
                  ></custom-select>
                </b-col> -->
                <b-col sm="12" md="10"></b-col>
                <b-col sm="12" md="2" class="text-right">
                  <b-button
                    block
                    variant="outline-primary"
                    size="lg"
                    @click="Refresh"
                  >
                    <p class="m-0 p-0 p-1">
                      <b-spinner v-if="Loading" small></b-spinner>
                      {{ $t("RefreshI") }}
                    </p>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>

          <b-col sm="12" md="12">
            <div class="pricing-box rounded px-4 pb-2 pt-2 mb-2 ">
              <b-row>
                <b-col sm="12" md="12">
                  <!-- <b-table :items="RegistrationOfAthleteList.Columns">
                  </b-table> -->
                  <b-table-simple bordered responsive>
                    <b-thead class="backColor">
                      <b-tr>
                        <b-th class="text-center" rowspan="3">
                          {{ $t("sporttype1") }}
                        </b-th>
                        <b-th class="text-center" colspan="10">
                          {{ $t("agestype") }}
                        </b-th>
                        <b-th rowspan="3" class="text-center">
                          {{ $t("totalSport") }}</b-th
                        >
                        <b-th rowspan="2" colspan="2" class="text-center">
                          {{ $t("fromThat") }}</b-th
                        >
                      </b-tr>
                      <b-tr>
                        <b-th colspan="2" class="text-center">
                          {{ $t("7to10ages") }}
                        </b-th>

                        <b-th colspan="2" class="text-center">
                          {{ $t("11to15ages") }}
                        </b-th>
                        <b-th colspan="2" class="text-center">
                          {{ $t("16to21ages") }}
                        </b-th>
                        <b-th colspan="2" class="text-center">
                          {{ $t("22to26ages") }}
                        </b-th>
                        <b-th colspan="2" class="text-center">
                          {{ $t("27to30ages") }}
                        </b-th>
                      </b-tr>
                      <b-tr>
                        <b-th>{{ $t("male") }}</b-th>
                        <b-th>{{ $t("female") }}</b-th>
                        <b-th>{{ $t("male") }}</b-th>
                        <b-th>{{ $t("female") }}</b-th>
                        <b-th>{{ $t("male") }}</b-th>
                        <b-th>{{ $t("female") }}</b-th>
                        <b-th>{{ $t("male") }}</b-th>
                        <b-th>{{ $t("female") }}</b-th>
                        <b-th>{{ $t("male") }}</b-th>
                        <b-th>{{ $t("female") }}</b-th>
                        <b-th>{{ $t("male") }}</b-th>
                        <b-th>{{ $t("female") }}</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody
                      v-for="(item, index) in RegistrationOfAthleteList"
                      :key="index"
                    >
                      <b-tr>
                        <b-td>
                          {{ item.sporttypename }}
                        </b-td>

                        <b-td class="text-center">{{
                          item.agecategory1count
                        }}</b-td>
                        <b-td class="text-center">{{
                          item.agecategory2count
                        }}</b-td>
                        <b-td class="text-center">{{
                          item.agecategory3count
                        }}</b-td>
                        <b-td class="text-center">{{
                          item.agecategory4count
                        }}</b-td>
                        <b-td class="text-center">{{
                          item.agecategory5count
                        }}</b-td>
                        <b-td class="text-center">{{
                          item.agecategory6count
                        }}</b-td>
                        <b-td class="text-center">{{
                          item.agecategory7count
                        }}</b-td>
                        <b-td class="text-center">{{
                          item.agecategory8count
                        }}</b-td>
                        <b-td class="text-center">{{
                          item.agecategory9count
                        }}</b-td>
                        <b-td class="text-center">{{
                          item.agecategory10count
                        }}</b-td>

                        <b-td class="text-center">
                          {{ item.totalcount }}
                        </b-td>
                        <b-td class="text-center">
                          {{ item.totalmalecount }}
                        </b-td>
                        <b-td class="text-center">
                          {{ item.totalfemalecount }}
                        </b-td>
                      </b-tr>
                    </b-tbody>
                    <b-tfoot class="backColor">
                      <b-tr>
                        <b-td>{{ $t("total") }}:</b-td>
                        <b-td class="text-center">{{
                          totalMale1 == 0 ? "-" : totalMale1
                        }}</b-td>
                        <b-td class="text-center">{{
                          totalFemale1 == 0 ? "-" : totalFemale1
                        }}</b-td>
                        <b-td class="text-center">{{
                          totalMale2 == 0 ? "-" : totalMale2
                        }}</b-td>
                        <b-td class="text-center">{{
                          totalFemale2 == 0 ? "-" : totalFemale2
                        }}</b-td>
                        <b-td class="text-center">{{
                          totalMale3 == 0 ? "-" : totalMale3
                        }}</b-td>
                        <b-td class="text-center">{{
                          totalFemale3 == 0 ? "-" : totalFemale3
                        }}</b-td>
                        <b-td class="text-center">{{
                          totalMale4 == 0 ? "-" : totalMale4
                        }}</b-td>
                        <b-td class="text-center">{{
                          totalFemale4 == 0 ? "-" : totalFemale4
                        }}</b-td>
                        <b-td class="text-center">{{
                          totalMale5 == 0 ? "-" : totalMale5
                        }}</b-td>
                        <b-td class="text-center">{{
                          totalFemale5 == 0 ? "-" : totalFemale5
                        }}</b-td>
                        <b-td class="text-center">{{
                          totalAll == 0 ? "-" : totalAll
                        }}</b-td>
                        <b-td class="text-center">{{
                          totalAllMale == 0 ? "-" : totalAllMale
                        }}</b-td>
                        <b-td class="text-center">{{
                          totalAllFemale == 0 ? "-" : totalAllFemale
                        }}</b-td>
                      </b-tr>
                    </b-tfoot>
                  </b-table-simple>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-overlay>
    <Footer />
  </div>
</template>

<script>
import Navbar from "../../components/navbar.vue";
import Footer from "../../components/footer.vue";
import {
  BIconPlus,
  BIconPencil,
  BIconTrash,
  BIconXCircle,
  BIconCheck2Circle,
  BIconCursor,
  BIconX,
  BIconEye,
  BIconCloudDownload,
  BThead,
  BTbody,
  BTfoot,
  BTr,
  BTh,
  BTd,
  BTable,
  BIconChevronLeft,
  BTableSimple,
  BIconClockHistory,
} from "bootstrap-vue";
import HelperService from "../../services/helper.service";
import CustomSelect from "../components/CustomSelect.vue";
import CustomInput from "../components/CustomInput.vue";
import ReportService from "../../services/report.service";
import SportTypeService from "../../services/sporttype.service";
export default {
  components: {
    Navbar,
    BIconPlus,
    Footer,
    CustomSelect,
    BTable,
    CustomInput,
    BIconPencil,
    BIconTrash,
    BIconXCircle,
    BTableSimple,
    BThead,
    BTbody,
    BTd,
    BTfoot,
    BTr,
    BTh,
    BIconCheck2Circle,
    BIconCursor,
    BIconX,
    BIconEye,
    BIconCloudDownload,
    BIconChevronLeft,
    BIconClockHistory,
  },
  data() {
    return {
      lang: localStorage.getItem("locale") || "uz_latn",
      AdoptionPermissionList: [],
      RegistrationOfAthleteList: {},
      DeleteLoading: false,
      filter: {
        sporttypeid: 0,
        genderid: 0,
      },
      totalMale1: 0,
      totalMale2: 0,
      totalMale3: 0,
      totalMale4: 0,
      totalMale5: 0,
      totalFemale1: 0,
      totalFemale2: 0,
      totalFemale3: 0,
      totalFemale4: 0,
      totalFemale5: 0,
      totalAll: 0,
      totalAllMale: 0,
      totalAllFemale: 0,
      SendLoading: false,
      ConfirmSendLoading: false,
      CancelLoading: false,
      Loading: false,
      downloadloading: false,
      AdoptPermisConclusion: {
        docnumber: "",
        docdate: "",
        commenttext: "",
        projectfiletext: "",
      },
      SportTypeList: [],
      GenderList: [],
      filterList: {
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 20,
        oblastid: 0,
        regionid: 0,
        regionsectorid: 0,
        genderid: 0,
        sporttypeid: 0,
        total: 0,
      },
    };
  },
  computed: {
    firstNumber() {
      return (this.filterList.PageNumber - 1) * this.filterList.PageLimit + 1;
    },
    lastNumber() {
      if (this.filterList.total < this.filterList.PageLimit) {
        return this.filterList.total;
      } else {
        if (
          this.filterList.PageNumber * this.filterList.PageLimit >
          this.filterList.total
        ) {
          return this.filterList.total;
        } else {
          return this.filterList.PageNumber * this.filterList.PageLimit;
        }
      }
    },
  },
  created() {
    this.Refresh();
    // SportTypeService.GetAll(
    //   this.lang,
    //   "",
    //   ""
    // ).then((res) => {
    //   this.SportTypeList = res.data;
    // });
    // HelperService.GetGenderList(this.lang).then((res) => {
    //   this.GenderList = res.data;
    // });
  },
  methods: {
    getColor(item) {
      if (item.statusid == 3 || item.statusid == 21) {
        return "danger";
      } else if (item.statusid == 1) {
        return "primary";
      } else {
        return "success";
      }
    },
    calculate() {
      var self = this;
      self.RegistrationOfAthleteList?.forEach(function(item) {
        self.totalMale1 += item.agecategory1count * 1;
        self.totalFemale1 += item.agecategory2count * 1;

        self.totalMale2 += item.agecategory3count * 1;
        self.totalFemale2 += item.agecategory4count * 1;

        self.totalMale3 += item.agecategory5count * 1;
        self.totalFemale3 += item.agecategory6count * 1;

        self.totalMale4 += item.agecategory7count * 1;
        self.totalFemale4 += item.agecategory8count * 1;

        self.totalMale5 += item.agecategory9count * 1;
        self.totalFemale5 += item.agecategory10count * 1;
        self.totalAll += item.totalcount * 1;
        self.totalAllMale += item.totalmalecount * 1;
        self.totalAllFemale += item.totalfemalecount * 1;
      });
    },
    Refresh() {
      this.Loading = true;
      this.totalMale1 = 0;
      this.totalMale2 = 0;
      this.totalMale3 = 0;
      this.totalMale4 = 0;
      this.totalMale5 = 0;
      this.totalFemale1 = 0;
      this.totalFemale2 = 0;
      this.totalFemale3 = 0;
      this.totalFemale4 = 0;
      this.totalFemale5 = 0;
      this.totalAll = 0;
      this.totalAllMale = 0;
      this.totalAllFemale = 0;
      ReportService
        .GetRegistrationOfAthleteCount
        // this.filterList.Search,
        // this.filterList.SortColumn,
        // this.filterList.OrderType,
        // this.filterList.PageNumber,
        // this.filterList.PageLimit,
        // this.filterList.oblastid,
        // this.filterList.regionid,
        // this.filterList.regionsectorid,
        // this.filterList.genderid,
        // this.filterList.sporttypeid
        ()
        .then((res) => {
          this.RegistrationOfAthleteList = res.data.data;
          this.Loading = false;
          this.calculate();
        })
        .catch((error) => {
          this.makeToast(error.response.data.error, "error");
          this.Loading = false;
        });
    },

    makeToast(message, type) {
      this.$toast.open({
        message: message,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style lang="scss">
.my-table-padding {
  tr {
    td,
    th {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
}
.backColor {
  background-color: #f2f2f2;
}
</style>
